import React from 'react'
import PropTypes from 'prop-types'
import { getSrc } from 'gatsby-plugin-image'
import { graphql, StaticQuery } from 'gatsby'
import ServiceCard from './ServiceCard'

const ProductPageTemplate = ({ image, title, heading, description }) => (
  <div>
    {/* Hero Section */}
    <div
      className="page-hero full-width-image margin-top-0"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${
          image && image.childImageSharp ? getSrc(image.childImageSharp.gatsbyImageData) : image
        })`,
      }}
    >
      <div className="hero-content-centered has-text-centered animate-fade-in-up">
        <h1 className="title is-1-desktop is-2-tablet is-3-mobile has-text-weight-bold hero-title mb-4">
          {title}
        </h1>
        {description && (
          <p className="subtitle is-4-desktop is-5-tablet is-6-mobile has-text-weight-normal hero-subtitle">
            {description}
          </p>
        )}
      </div>
    </div>

    {/* Services Section */}
    <section className="section py-6-desktop py-5-tablet py-4-mobile">
      <div className="container">
        <div className="columns is-centered">
          <div className="column is-12">
            {heading && (
              <div className="has-text-centered mb-6">
                <h2 className="title is-2-desktop is-3-tablet is-4-mobile">
                  {heading}
                </h2>
              </div>
            )}

            {/* Services Grid */}
            <StaticQuery
              query={graphql`
                query ServicesQuery {
                  allMarkdownRemark(
                    filter: { frontmatter: { templateKey: { eq: "service-detail" } } }
                    sort: { frontmatter: { order: ASC } }
                  ) {
                    edges {
                      node {
                        id
                        fields {
                          slug
                        }
                        frontmatter {
                          title
                          icon
                          shortDescription
                          featuredImage
                          featured
                          features {
                            text
                          }
                        }
                      }
                    }
                  }
                }
              `}
              render={(data) => {
                const services = data.allMarkdownRemark.edges

                return (
                  <div className="services-grid">
                    {services && services.length > 0 ? (
                      <div className="columns is-multiline">
                        {services.map(({ node: service }) => (
                          <ServiceCard
                            key={service.id}
                            service={{
                              slug: service.fields.slug,
                              frontmatter: service.frontmatter,
                            }}
                          />
                        ))}
                      </div>
                    ) : (
                      <div className="box has-text-centered py-6">
                        <span className="icon is-large has-text-grey-light mb-4">
                          <i className="fas fa-briefcase fa-3x"></i>
                        </span>
                        <p className="title is-5 has-text-grey">
                          No Services Available Yet
                        </p>
                        <p className="subtitle is-6 has-text-grey-light">
                          We're preparing our service offerings
                        </p>
                      </div>
                    )}
                  </div>
                )
              }}
            />
          </div>
        </div>
      </div>
    </section>
  </div>
)

ProductPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
}

export default ProductPageTemplate
